import React, { useRef, useState, useEffect } from 'react';
import './CheckboxInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function CheckboxInput({ validate, initialValue, onValidate, name, label, instructions, explanation, disabled }) {
  if (logComponent('CheckboxInput')) { console.debug('CheckboxInput rendered'); }

  const nativeCheckboxRef = useRef(null);
  const [selected, setSelected] = useState(initialValue ? initialValue : false);
  const [needSubmitValue, setNeedSubmitValue] = useState(false);

  const setNativeCheckboxRef = (el) => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput setNativeCheckboxRef'); }
    nativeCheckboxRef.current = el;
  }

  const clickNativeCheckbox = () => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput clickNativeCheckbox'); }
    if (nativeCheckboxRef.current) nativeCheckboxRef.current.click();
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput onMount'); }
    if (selected !== null) submitValue();
  }, []);

  useEffect(() => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput useEffect [validate]'); }
    submitValue();
  }, [validate]);

  useEffect(() => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput useEffect [needSubmitValue]'); }
    if (needSubmitValue === true) submitValue();
    setNeedSubmitValue(false);

  }, [needSubmitValue]);

  useEffect(() => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput useEffect [initialValue]'); }
    setSelected(initialValue);
    setNeedSubmitValue(true);
  }, [initialValue]);


  const submitValue = () => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput submitValue'); }
    onValidate({
      name: name,
      isValid: true,
      value: selected
    });
  }

  const toggleSelected = () => {
    if (logComponent('CheckboxInput')) { console.debug('CheckboxInput toggleSelected'); }
    setSelected(!selected);
    setNeedSubmitValue(true);

  }
   
  return (
    <div className="Checkbox-Input-Group">    
      <label 
        className="Checkbox-Input-Group__label"
        htmlFor={name + '-input'}>
        { label }
      </label>
      <input 
        ref={setNativeCheckboxRef}
        type="checkbox" 
        className="Checkbox-Input-Group__native-checkbox"
        id={name + '-input'}
        checked={selected}
        onChange={toggleSelected}
        disabled={disabled} />
      <div className="Checkbox-Input-Group__explanation">  
        <div className="Checkbox-Input-Group__outline" onClick={clickNativeCheckbox}>
          <FontAwesomeIcon className={'Checkbox-Input-Group__check' + (selected ? ' visible' : '')} icon="check"></FontAwesomeIcon>
        </div>
        <p className="Checkbox-Input-Group__explanation-text">{ explanation }</p>
      </div>
    { 
      instructions &&
      <span className="Checkbox-Input-Group__instructions">{ instructions }</span>
    }
    </div>
  );
}